function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M46.166 22.692c-.688-.303-1.561-.195-2.397.145-3.151 1.274-5.296 1.734-8.61.698-2.086-.652-4.04-2.02-6.35-1.186-1.53.55-2.958 1.074-4.69 1.06l-1-5.118h23.767l-.72 4.4zM38.11 37.89s-1.153 1.184-3.03 1.055c-1.881.129-3.032-1.055-3.032-1.055-1.903-1.896-1.224-4.257-.561-5.476.408-.765 3.33-5.146 3.582-5.518v-.03l.01.014.012-.014v.03c.246.373 3.172 4.753 3.58 5.518.664 1.219 1.34 3.58-.561 5.476zm9.816-20.617a.308.308 0 00-.23-.102H22.3a.306.306 0 00-.228.102.296.296 0 00-.064.239l4.267 25.755a.298.298 0 00.292.248h5.236l.359 4.193-2.204.002 5.127 5.117 5.14-5.127-2.203.002.357-4.188h5.328c.146 0 .27-.107.292-.253l3.99-25.75a.291.291 0 00-.064-.238z"
});

var SvgOds06 = function SvgOds06(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOds06, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ods06.d799a063.svg";
export { ForwardRef as ReactComponent };